module.exports = __webpack_public_path__ + "static/juice-vid-new_3-ce3f95f57f681416e78b4bddab6a855b.mp4";